import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataDictionarySearchSlice } from './get';

export const coreDataDictionarySearchReducers = combineReducers({
	get: getCoreDataDictionarySearchSlice.asyncReducers
});

export const coreDataDictionarySearchWatchers = combineAllWatchers([ getCoreDataDictionarySearchSlice.asyncWatchers ]);
